import {
  PromotionBanner
} from '../models';

const mapRelationships = (obj, included) => {

  return Object.keys(obj).flatMap((key) => {

    const item = obj[key];

    return item.data.flatMap((rel) => {

      return included.flatMap((meta) => {

        if (rel.id === meta.id) {

          return {

            id: meta.id,
            type: meta.type,
            field: key,
            title: meta.attributes?.field_title,
            caption: meta.attributes?.field_caption?.value,
            url: meta.attributes?.field_click_out_url,
            ...mapPromotionRelationships(meta?.relationships, included)?.[0]
          };
        }
        return [];
      });
    });
  });
};

const mapPromotionRelationships = (obj, included) => {

  return Object.keys(obj).flatMap((key) => {

    const item = obj[key];

    return included.flatMap((meta) => {

      if (item?.data?.id === meta.id) {

        return {

          image: meta?.attributes?.uri?.url
        };
      }
      return [];
    });
  });
};

export const mapPromotionBanner = (result) => {

  return result.data
    .map((item) => {

      return {

        attributes: {
          ...item.attributes,
          relationships: mapRelationships(item.relationships, result.included),
          id: item.id
        }
      };
    })
    .map((content) => {

      return new PromotionBanner(content).mapToStandard();
    });
};
